import { UserContextProvider } from 'core/context/UserContext';
import { TranslationContextProvider } from 'core/context/TranslationContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import MainRoutes from 'routes/MainRoutes';


const queryClient = new QueryClient()

function App() {

  return (
    <BrowserRouter basename="/">
      <TranslationContextProvider>
        <UserContextProvider>
          <QueryClientProvider client={queryClient}>
            <MainRoutes />
          </QueryClientProvider>
        </UserContextProvider>
      </TranslationContextProvider>
    </BrowserRouter>
  );
}

export default App;
